import { render, staticRenderFns } from "./CinemaLogin.vue?vue&type=template&id=3e65f298&"
import script from "./CinemaLogin.vue?vue&type=script&lang=js&"
export * from "./CinemaLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports